<template>
  <div class="df width-100 pt-4 pb-1">
    <v-container fluid class="pl-2 pr-2">
      <v-row>
        <v-col cols="3" class="pa-0 d-flex align-center font-17">
          <span v-if="exibirIdPedidoExportado" v-text="`Pedido exportado: #${pedidoSelecionado.pedido_cli}`" />
          <span v-else>Produtos a Comprar</span>

          <div v-show="!pedidoSelecionado.pedido_produtos_combinados && produtosSelecionados.length > 0">
            <v-btn
              color="#013254"
              class="ml-5"
              @click="dialog_ajuste_pedido = true"
              small dark
            >
              ajustar pedido
              <span class="qtde-top-button-small">{{ produtosSelecionados.length }}</span>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="2" class="pa-0">
          <div v-show="produtosSelecionados.length > 0">
            <v-btn
              color="red"
              @click="deleteMultiplosProdutos"
              small dark
            >
              <v-icon small left>mdi-delete</v-icon>
              <span>Remover</span>
              <span class="qtde-top-button-small">{{ produtosSelecionados.length }}</span>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="2" class="pa-0">
          <div id="converter" v-if="pedidoSelecionado.conv_emb_master == 'S'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div class="df">
                  <v-icon
                    color="#666"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="converterEmbalagem"
                  >
                    mdi-repeat
                  </v-icon>
                  <h6 class="ml-4">
                    {{ pedidoSelecionado.emb_master == 'S' ? "Embalagem Master" : "Embalagem Mínima" }}
                  </h6>
                </div>
              </template>
              <span v-if="pedidoSelecionado.emb_master == 'S'">
                Converter para Unidade Mínima
              </span>
              <span v-else>Converter para Embalagem Master</span>
            </v-tooltip>
          </div>
        </v-col>

        <v-col cols="5" class="pa-0">
          <div class="df">
            <v-text-field
              v-model="PESQUISA"
              append-icon="mdi-magnify"
              label="Pesquisar produto"
              single-line
              hide-details
              clearable
              class="mt-0 pt-0 ml-10 mr-2"
            ></v-text-field>
            <div class="ml-5" v-if="pedidoSelecionado.status === 'CT'">
              <v-btn @click="atualizarSugestao()" outlined small color="default">
                <v-icon title="Atualizar quantidades de produtos">
                  mdi-cached
                </v-icon>
              </v-btn>
            </div>

            <v-tooltip top open-delay="600">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                </span>
              </template>
              <span>Fracionar todos os itens do pedido.</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <DialogAjustePedido
      v-if="!pedidoSelecionado.pedido_produtos_combinados"
      v-model="dialog_ajuste_pedido"
      :idpedido="pedidoSelecionado.idpedido"
      :filial_pedido="pedidoSelecionado.filial_compra"
      :idprodutos="produtosSelecionados.map((i) => i.idproduto)"
      :fornecedores="[pedidoSelecionado.idfornecedor]"
      :filtros_gerais_inicial="{
        linhas: linhasCompra.map(item => String(item)),
      }"
      :descricao_fornecedor="pedidoSelecionado.descricao_grupo_analise_fornecedor"
      tipo_compra="FC"
      @atualizar-pedido="atualizarPedido"
    />
  </div>
</template>

<script>
import CompraAPI from "@/api/compra";
import PedidoFracionado from "./PedidoFracionado";
import DialogAjustePedido from "@/components/compra/ProdutosGerais/Carrinho/Meta/Index.vue";
import {mapGetters} from "vuex";

export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: ["modelValue", "pedidoSelecionado", "produtosSelecionados"],
  components: { DialogAjustePedido, PedidoFracionado },
  data: () => ({
    search: "",
    dialog_ajuste_pedido: false
  }),
  computed: {
    ...mapGetters({
      linhasCompra: "linhasCompra/getItens",
    }),
    exibirIdPedidoExportado() {
      return (
        this.pedidoSelecionado.pedido_cli &&
        this.pedidoSelecionado.pedido_cli.length > 1
      );
    },
    PESQUISA: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  },
  methods: {
    atualizarSugestao: function () {
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store
        .dispatch("carrinho/atualizarPedidoGrupo", {
          pedido: this.pedidoSelecionado.idpedido,
          grupo: this.pedidoSelecionado.grupo,
        })
        .then(response => {
          const { token, produtosAConfirmar } = response
          localStorage.setItem("token", token);
          this.$emit("atualizarPedidos");

          if (produtosAConfirmar.length) {
            this.$emit('produtos-a-confirmar', produtosAConfirmar)
          }
        })
      );
    },
    converterEmbalagem: function () {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idpedido: this.pedidoSelecionado.idpedido,
        emb: this.pedidoSelecionado.emb_master === "S" ? "N" : "S",
      };
      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.converterEmbalagem(headers, params)
        .then((response) => {
          localStorage.setItem("token", response.data.token);

          this.$store.dispatch(
            "EmbalagemTelaDeCompras/setEmbalagemMaster",
            params.emb === "S"
          );

          this.$emit("atualizarPedidos");
        })
        .catch(() => this.Helpers.logout())
      );
    },
    deleteMultiplosProdutos() {
      this.$emit("excluir-produtos", this.produtosSelecionados);
      // const produtosAdicionados = { ids: [] };
      // this.produtosSelecionados.forEach((produto) => {
      //   produto.carrinho = 0;
      //   produtosAdicionados.ids.push({
      //     pedido: this.pedidoSelecionado.idpedido,
      //     produto: produto.idproduto,
      //     fornecedor: produto.idfornecedor,
      //     grupo: produto.grupo,
      //   });
      // });
      // this.$store.dispatch(
      //   "loading/addRequisicao",
      //   this.$store
      //     .dispatch("carrinho/Delete", produtosAdicionados)
      //     .then(() => {
      //       this.$emit("deletou");
      //     })
      // );
    },
    atualizarPedido() {
      this.$emit("atualizarPedidos");
    }
  },
};
</script>

<style scoped>
</style>
